import { render, staticRenderFns } from "./Occupation.vue?vue&type=template&id=45a9013d&scoped=true"
import script from "./Occupation.vue?vue&type=script&lang=js"
export * from "./Occupation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a9013d",
  null
  
)

export default component.exports